const wowApp = require('angular').module('wowApp.auth');

wowApp.component('wowLoginForgotPassword', require('./forgot-password.component').forgotPasswordComponentDefinition);



// WEBPACK FOOTER //
// ./src/auth/forgotpassword/index.js